export default __webpack_public_path__ + "static/media/x.e20279ac.svg";